import config from '../nyConfig'
const ApiHomestay = {
    "民宿信息审核列表": new config({url: '/homestay/auditing/pageHomestay', showSuccessMessage: false, useToken: true }),
    "民宿信息审核列表统计": new config({url: '/homestay/auditing/countLand', showSuccessMessage: false, useToken: true }),
    "民宿信息详情": new config({url: '/homestay/auditing/homestayInfo', showSuccessMessage: false, useToken: true }),
    "修改民宿基本信息": new config({url: '/homestay/auditing/updateBaseInfo', showSuccessMessage: true, useToken: true }),
    "修改民宿位置": new config({url: '/homestay/auditing/updateAddressInfo', showSuccessMessage: true, useToken: true }),
    "修改民宿联系人": new config({url: '/homestay/auditing/updateContactsInfo', showSuccessMessage: true, useToken: true }),
    "民宿审核通过": new config({url: '/homestay/auditing/passAuditing', showSuccessMessage: true, useToken: true }),
    "民宿审核拒绝": new config({url: '/homestay/auditing/refuseAuditing', showSuccessMessage: true, useToken: true }),
    "民宿暂停/继续发布": new config({url: '/homestay/auditing/operationLand', showSuccessMessage: true, useToken: true }),
    "民宿批量下架": new config({url: '/homestay/auditing/batchDeList', showSuccessMessage: true, useToken: true }),
}

export default ApiHomestay
